<h1>{{title}}</h1>

<app-quote></app-quote>

<section>
<router-outlet></router-outlet>
</section>